import { CharacterLicense } from '~/shared';
import {
	IVehiclePassportAndHistory,
	IVehiclePassportService,
} from './vehiclePassportServiceTypes';

export class VehiclePassportServiceStub implements IVehiclePassportService {
	public async getPassportAndHistory(): Promise<IVehiclePassportAndHistory> {
		const passport = {
			name: 'BMW M5 F90',
			brandName: 'BMW',
			modelName: 'M5 F90',
			bodyType: 'Седан',
			licenseCategory: CharacterLicense.DrivingCar,
			ownersCount: 18,
			enginePower: 524,
			registryCityName: 'г. Лос-Сантос',
			ownerNickname: 'a.bakhia',
			registryPlaceName: 'п. Департамент Лос-Сантоса',
			vinNumber: 'MWB00000000000004',
			docNumber: '000000024',
			duplicate: true,
		};

		const lastOwnersHistory = [
			{
				ownerNickname: '#Strix',
				createdAt: '01.04.2024',
				mileage: 2740,
			},
			{
				ownerNickname: 'a.bakhia',
				createdAt: '01.04.2024',
				mileage: 14110,
			},
			{
				ownerNickname: 'SENADES',
				createdAt: '22.04.2024',
				mileage: 1006,
			},
			{
				ownerNickname: 'SENADES',
				createdAt: '22.04.2024',
				mileage: 1006,
			},
			{
				ownerNickname: 'SENADES',
				createdAt: '22.04.2024',
				mileage: 1006,
			},
			{
				ownerNickname: 'SENADES',
				createdAt: '22.04.2024',
				mileage: 1006,
			},
		];

		return {
			passport,
			lastOwnersHistory,
		};
	}

	public async exit(): Promise<void> {
		console.log('vehiclePassport:exit');
	}
}
